// Work tab task-completion status, derived from a close's
// terminatedTasksCount/totalTaskCount (the same numbers the Progress column
// shows). A close with no tasks at all counts as NOT_STARTED.
export enum CloseProgressStatus {
    NOT_STARTED = "not_started",
    IN_PROGRESS = "in_progress",
    ALL_TASKS_DONE = "all_tasks_done",
}

export const closeProgressStatusLabels: Record<CloseProgressStatus, string> = {
    [CloseProgressStatus.NOT_STARTED]: "Not started",
    [CloseProgressStatus.IN_PROGRESS]: "In progress",
    [CloseProgressStatus.ALL_TASKS_DONE]: "All tasks done",
};
